import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthenticationContainer } from 'entities/Authentication';
import { Flex, Typography } from 'shared/_ui';

import styles from './styles.module.scss';

type LocationState = {
  email?: string;
  setupUrl?: string;
  telegramBindUrl?: string;
  returningUser?: boolean;
};

const SUPPORT_EMAIL = 'support@irs-lab.fr';

export const RussiaOnboardingSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const state = location.state as LocationState | null;
  const email = state?.email;
  const setupUrl = state?.setupUrl;
  const returning = state?.returningUser;
  const telegramBindUrl = state?.telegramBindUrl;
  const supportMailto = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
    t('landing.russia.success.supportSubject')
  )}`;

  return (
    <AuthenticationContainer title={t(returning ? 'landing.russia.returning.title' : 'landing.russia.success.title')}>
      <Flex direction="column" spacing={24} className={styles.wrapper}>
        <div className={styles.notice}>
          <Typography.Text type="success" strong className={styles.badge}>
            {t(returning ? 'landing.russia.returning.badge' : 'landing.russia.success.badge')}
          </Typography.Text>
          <Typography.Text type="secondary" className={styles.text}>
            {returning
              ? t(setupUrl ? 'landing.russia.returning.description' : 'landing.russia.returning.noConnection')
              : email
              ? t('landing.russia.success.descriptionWithEmail', { email })
              : t('landing.russia.success.description')}
          </Typography.Text>
        </div>

        <Flex direction="column" spacing={12}>
          {setupUrl && (
            <a
              className={styles.primaryAction}
              data-gtm-event-name="click_ActivateVpn"
              href={setupUrl}
            >
              {t('landing.russia.success.activateButton')}
            </a>
          )}
          {returning && !setupUrl && telegramBindUrl && (
            <a className={styles.primaryAction} href={telegramBindUrl}>
              {t('landing.russia.returning.telegramButton')}
            </a>
          )}
          <div className={styles.support}>
            <Typography.Text type="secondary">
              {t('landing.russia.success.supportButton')}
            </Typography.Text>
            <a
              className={styles.supportEmail}
              data-gtm-event-name="click_OnboardingSupport"
              href={supportMailto}
            >
              {SUPPORT_EMAIL}
            </a>
          </div>
        </Flex>
      </Flex>
    </AuthenticationContainer>
  );
};
